import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import  ImageGallery  from "react-image-gallery";


// import "react-image-gallery/styles/scss/image-gallery.scss";
import "react-image-gallery/styles/css/image-gallery.css";
import './blc_gallery_two.css';





const Blc_Gallery_Two = (props)=>{
  
  let imagesOne= [];
  
   props.valEachBlc.gallery_album.map((val,index)=>{
    let valOne = {
      description: '',
      original: '',
      thumbnail: '',
      
    }

     
       valOne.description = val.Description;
       valOne.original = val.photos.data[0].attributes.url;
       valOne.thumbnail = val.photos.data[0].attributes.url;
      
       imagesOne.push(valOne);
       
   })
  
  return (
    <>
      <Container className="my-modal-two">
        <Row>
          <Col>
          <ImageGallery items={imagesOne} /> 
          
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Blc_Gallery_Two;
